import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment-timezone';
import { useRecoilValueLoadable } from 'recoil';
import { getBusinessProductsPHP } from '../../../recoil/selectors/getBusinessProductsPHP';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../services/rest/makeAPIRequest';
import { DefaultActionSkeleton } from '../../components/dropdowns/DefaultAction';
import { ModalWithStyles } from './ModalWithStyles';

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  table: {
    marginBottom: theme.spacing(4), // align with fields
  },
}));
export interface IBusinessProductsContent {
  pdescription: string;
  count?: string;
  totalamt?: string;
}

export default function ViewBreakdownModal({
  show,
  handleClose,
  billingCycleTotal,
}) {
  const data = {
    call: methodNameEnum.GET_BUSINESS_DATA,
  };
  const businessData = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify(data),
    })
  );
  const classes = useStyles();
  const businessProducts = useRecoilValueLoadable(getBusinessProductsPHP);
  return (
    <ModalWithStyles
      show={show}
      onSubmit={() => {}}
      aria-labelledby="example-modal-sizes-title-sm"
      title="View Breakdown"
      onHide={() => {
        handleClose();
      }}
      isLoading={businessProducts.state === 'loading'}
      size="sm"
      footerComponent={
        <>
          <Button
            variant="contained"
            disableElevation={true}
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
        </>
      }
    >
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell valign="baseline">Product Type</TableCell>
            <TableCell valign="baseline" align="center">
              Count
            </TableCell>
            <TableCell align="right" valign="baseline" width="100">
              Total $
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {businessProducts.state === 'loading' && (
            <TableRow>
              <TableCell>
                <DefaultActionSkeleton />
              </TableCell>
              <TableCell align="center">
                <DefaultActionSkeleton />
              </TableCell>
              <TableCell>
                <DefaultActionSkeleton />
              </TableCell>
            </TableRow>
          )}
          {businessProducts?.state !== 'loading' &&
            businessProducts?.contents
              ?.reduce((arr, product) => {
                const productTypes = arr.map(
                  (productType) => productType.productid
                );
                const shouldHaveDiscount =
                  !!(
                    businessData?.contents?.response?.data?.result?.[0]?.discountEndDate?.substring?.(
                      0,
                      10
                    ) >= moment(product.invoiceduntil).format('YYYY-MM-DD') ||
                    !businessData?.contents?.response?.data?.result?.[0]
                      ?.discountEndDate
                  ) &&
                  !!product.canHaveDiscount &&
                  !!businessData?.contents?.response?.data?.result?.[0]
                    ?.discountPercent;
                const discountPrice =
                  product.status === 'active'
                    ? (shouldHaveDiscount
                        ? (100 -
                            (businessData?.contents?.response?.data?.result?.[0]
                              ?.discountPercent ?? 0)) /
                          100
                        : 1) *
                      (Number(product.priceperunit.split('$').join('')) *
                        product.paymentduration)
                    : 0;
                if (productTypes.indexOf(product.productid) == -1) {
                  const clonedBusinessProducts = {
                    productid: product.productid,
                    units: product.units,
                    pdescription: product.pdescription,
                    totalamt: discountPrice,
                    status: product.status,
                    invoiceduntil: product.invoiceduntil,
                  };
                  arr.push(clonedBusinessProducts);
                } else {
                  const productIndex = productTypes.indexOf(product.productid);
                  arr[productIndex].units += product.units;
                  if (product.totalamt) {
                    const currTotalAmt = arr[productIndex].totalamt;
                    arr[productIndex].totalamt = currTotalAmt + discountPrice;
                  }
                }
                return arr;
              }, [])
              .filter((product) => product.pdescription !== ' ')
              .filter((product) => product.totalamt !== 0)
              .map((product: any, index: number) => (
                <TableRow key={product.productid}>
                  <TableCell valign="baseline">
                    {product.pdescription}
                  </TableCell>
                  <TableCell align="center" valign="baseline">
                    {product.units}
                  </TableCell>
                  <TableCell
                    align="right"
                    valign="baseline"
                    padding="none"
                    style={{ paddingRight: 16 }}
                  >
                    ${product.totalamt.toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </ModalWithStyles>
  );
}
